import { useEffect } from "react";
import { useState } from "react";
import { useFetch } from "../../../common/hooks/useFetch";
import { listTasksKanbanService } from "../services/listTasksKanban.service";
import debounce from "lodash.debounce";

const LIMIT = 25;

export const useTasksQuery = (filters) => {
  const fetchData = useFetch();
  const [tasks, setTasks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [refresh, setRefresh] = useState(false);

  useEffect(() => {
    const fetchTasks = async () => {
      try {
        setLoading(true);
        const response = await listTasksKanbanService(fetchData)({
          limit: LIMIT,
          offset: (currentPage - 1) * LIMIT,
          ...filters,
        });
        setTasks(response.data);
        setTotalPages(response.totalPages ?? 0);
        setTotalItems(response.total ?? 0);
      } catch (error) {
        console.error("Error:", error);
      } finally {
        setLoading(false);
      }
    };

    const debounced = debounce(fetchTasks, 600);
    debounced();
    return () => debounced.cancel();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    filters?.status,
    filters?.type,
    filters?.startDate,
    filters?.endDate,
    currentPage,
    refresh,
  ]);

  return {
    tasks,
    loading,
    currentPage,
    totalPages,
    totalItems,
    refresh: () => setRefresh((prev) => !prev),
    onChangePage: (page) => setCurrentPage(page),
  };
};
